import ProcessRequestExecutionStateStatistics from '@app/model/process-request/ProcessRequestExecutionStateStatistics';
import Process from '@app/model/process-request/Process';
import ProcessRequestState from '@app/model/process-request/ProcessRequestState';
import ProcessRequestResult from '@app/model/process-request/ProcessRequestResult';


class ProcessRequestExecutionState {
	requestId: number;
	process: Process;
	profileId?: number;
	companyId?: number;
	companyHotelId?: number;
	state: ProcessRequestState;
	result: ProcessRequestResult;
	statistics: {
		taskStatistics: ProcessRequestExecutionStateStatistics;
		triggerStatistics: ProcessRequestExecutionStateStatistics;
	}


	constructor(data: ProcessRequestExecutionState) {
		const statistics = data.statistics ?? data;

		this.requestId = data.requestId;
		this.process = data.process;
		this.profileId = data.profileId;
		this.companyId = data.companyId;
		this.companyHotelId = data.companyHotelId;
		this.state = data.state;
		this.result = data.result;
		this.statistics = {
			taskStatistics: new ProcessRequestExecutionStateStatistics(statistics.taskStatistics),
			triggerStatistics: new ProcessRequestExecutionStateStatistics(statistics.triggerStatistics),
		};
	}

	get isFinished(): boolean {
		return this.state === ProcessRequestState.FINISHED;
	}

	get hasFailed(): boolean {
		return this.isFinished && this.result === ProcessRequestResult.FAILED;
	}

	get isSuccessful(): boolean {
		return this.isFinished && (this.result === ProcessRequestResult.SUCCESS || this.result === ProcessRequestResult.SUCCESS_NO_CHILDREN);
	}

	get isEmpty(): boolean {
		return this.statistics.taskStatistics.total === 0;
	}

	get progressPercentage(): number {
		return this.statistics.taskStatistics.percentage;
	}

}

export default ProcessRequestExecutionState;
